import { types } from "../actions/types";

const initialState = {
    id: 0,
    name: "",
    code: "",
};

export const languageReducer = (state = initialState, action) => {
    const { type = '' } = action;

    if (type === types.updateLanguage) {
        return { ...state, ...action.payload };
    }

    return state;
};
